<template>
  <div class="subpage light-bg">
    <header-component />
    <section id="content-section" class="content">
      <div class="container">
        <loader-component :is-loaded="pageLoaded" title="Sayfa yüklenirken lütfen bekleyin.."></loader-component>

        <nav v-show="pageLoaded" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a @click="$router.push('/')">Anasayfa</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ content.name }}</li>
          </ol>
        </nav>

        <h2 v-show="pageLoaded" v-if="content.bannerImageUrl === ''" class="section-title">{{ content.name }}</h2>
        <div v-show="pageLoaded" v-if="content.bannerImageUrl !== ''" class="row justify-content-start mt-3">
          <div class="col">
            <div class="content-bg">
              <img :src="content.bannerImageUrl" alt="..." class="img-fluid" />

              <div class="content-bg-title">
                <div class="row justify-content-between">
                  <div class="col">
                    <h1 class="caption px-3 py-3 px-lg-5 py-lg-4">{{ content.name }}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="pageLoaded" v-if="!content.pageList?.length" class="row justify-content-center mb-5">
          <div class="col-12">
            <div class="bg-white px-3 px-lg-5 py-3 py-lg-5 rounded-lg shadow-sm mb-4">
              <div class="content-html" v-html="content.detail"></div>

              <div v-if="content.hasImageGallery" class="gallery photo">
                <h4 class="content-title">Fotoğraflar</h4>
                <fancybox-component
                  :options="{
                    Carousel: {
                      infinite: false,
                    },
                  }"
                >
                  <div class="row mb-5 position-relative content-back gy-4">
                    <div class="item col-6 col-md-3 col-lg-4 col-xl-3" v-for="(image, index) in content.imageGalleries" :key="index">
                      <div class="bg rounded">
                        <div class="img">
                          <img :src="image.imageUrl" alt="..." class="img-fluid rounded" />
                        </div>
                        <img :src="image.imageUrl" alt="..." class="img-fluid rounded" />
                        <h6>{{ image.title }}</h6>
                        <a data-fancybox="gallery" :href="image.imageUrl" :data-caption="image.title">
                          &nbsp;
                          <!--                          <img class="card-img" :src="image.imageUrl" alt="">-->
                        </a>
                      </div>
                    </div>
                  </div>
                </fancybox-component>
              </div>

              <div v-if="content.hasVideoGallery" class="gallery video">
                <h4 class="content-title">Videolar</h4>
                <fancybox-component
                  :options="{
                    Carousel: {
                      infinite: false,
                    },
                  }"
                >
                  <div class="row mb-5 position-relative content-back gy-4">
                    <div class="item col-6 col-md-3 col-lg-4 col-xl-3" v-for="(video, index) in content.videoGalleries" :key="index">
                      <div class="bg rounded">
                        <div class="img">
                          <img :src="video.imageUrl" alt="..." class="img-fluid rounded" />
                        </div>
                        <img :src="video.imageUrl" alt="..." class="img-fluid rounded" />
                        <h6>{{ video.title }}</h6>
                        <a data-fancybox="gallery" :href="video.videoUrl" :data-caption="video.title">
                          <img class="card-img" :src="video.videoUrl" alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </fancybox-component>
              </div>
            </div>
          </div>
        </div>
        <div v-show="pageLoaded" v-else>
          <div class="row mt-4 mb-2">
            <!--Begin:  div.sm-4 -->
            <div class="col-md-6 mb-3" v-for="(item, index) in content.pageList" :key="index">
              <div class="card card-icerikliste text-white card-has-bg click-col" :style="{'background-image': 'url(' + item.imageUrl + ')'}">
                <img class="card-img" :src="item.imageUrl" alt="" />
                <div class="card-img-overlay d-flex flex-column">
                  <div class="card-body">
                    <h3 class="card-title mt-0 mb-1 mb-md-3">{{ item.name }}</h3>
                    <p>{{ item.detail }}</p>
                  </div>
                  <div class="card-footer">
                    <a class="mt-1" @click="$router.push({name: 'content-page-detail', params: {id: item.pageId}})">AYRINTILAR</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-component />
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import Fancybox from "@/components/Fancybox.vue";
import apiService from "@/services/service";
import LoaderComponent from "@/components/LoaderComponent";

export default {
  name: "HomeView",
  components: {
    "header-component": HeaderComponent,
    "footer-component": FooterComponent,
    "fancybox-component": Fancybox,
    "loader-component": LoaderComponent,
  },

  props: ["id", "title", "endpoint", "preview"],

  watch: {
    id: {
      handler() {
        this.getPageContent();
      },
    },
  },

  created() {
    this.getPageContent();
  },

  methods: {
    getPageContent() {
      const endpoint = this.endpoint == "content-page-detail" ? "Page/detail/" : "Page/";
      const previewParam = this.preview ? `?prv=2025` : "";
      apiService
        .getPageApiData(endpoint + this.id + previewParam)
        .then((res) => {
          this.content = res.model;
          this.pageLoaded = true;
          document.title = this.content.name + window.PAGETITLE;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

  data() {
    return {
      pageLoaded: false,
      content: {
        pageList: [],
      },
    };
  },
};
</script>

<style lang="scss">
$color_1: #fff;

table {
  max-width: 100%;
  margin: 10px auto;
  width: 100%;
}

caption {
  font-size: 1.6em;
  font-weight: 400;
  padding: 10px 0;
}

thead {
  th {
    font-weight: 400;
    background: #8a97a0;
    color: $color_1;
  }
}

tbody {
  tr {
    &:first-child {
      font-weight: 400;
      background: #8a97a0;
      position: sticky;
      top: 0;

      strong {
        color: $color_1 !important;
      }
    }
  }
}

tr {
  background: #f4f7f8;
  border-bottom: 1px solid #fff;
  margin-bottom: 5px;

  &:nth-child(odd) {
    background: #e8eeef;
  }
}

th {
  text-align: left;
  padding: 20px 12px;
  font-weight: 300;
}

td {
  text-align: left;
  padding: 20px 12px;
  font-weight: 300;
}

img {
  max-width: 100%;
}

.table {
  overflow-x: auto;
}
a {
  cursor: pointer;
}
</style>
